/* eslint-disable import/first */
import React from "react";
import { CRUD_MODELS, ROUTES } from "../constants";
import { useAuth0 } from "@auth0/auth0-react";

import async from "../components/Async";

import {
  Database,
  Home,
  Monitor,
  Users,
  Map as MapIcon,
  Search,
  FileText,
  Download,
} from "react-feather";

import Landing from "../pages/presentation/Landing";
import * as inflector from "inflected";
import { CrudProvider } from "../CrudProvider";

// TODO MAYBE LAZY IMPORT
import PublicMap from "../pages/publicMap";
import Default from "../pages/dashboards/Default";
import EditBenchmarks from "../pages/dataManagement/EditBenchmarks";
import AdminGuard from "../components/AdminGuard";
import AdminVisibilityFilter from "../components/AdminVisibilityFilter";
import WaterQualityReportCard from "../pages/dataAccess/Reports/WaterQualityReportCard";
import AuthGuard from "../components/AuthGuard";
import UserVisibilityFilter from "../components/UserVisibilityFilter";
import QueryAndDownload from "../pages/dataAccess/QueryAndDownload/QueryAndDownload";
const Account = async(() => import("../pages/pages/Account"));
const Profile = async(() => import("../pages/pages/Profile"));

const CrudIndexPage = async(() => import("../components/crud/CrudIndexPage"));
const CrudViewPage = async(() => import("../components/crud/CrudViewPage"));

const getSidebarMenu = (list) => {
  return list.map((item) => {
    const slug = inflector.dasherize(inflector.underscore(item.name));
    return {
      id: item.sidebarName ?? inflector.titleize(item.name),
      path: `/models/${slug}`,
      model: inflector.singularize(item.name),
      icon: item.icon || <Database />,
      component: CrudIndexPage,
      config: require(`../pages/models/${item.name}Config`),
      provider: CrudProvider,
      children: item.children,
      header: item.header,
      guard: item.guard,
      visibilityFilter: item.visibilityFilter,
    };
  });
};

const getCrudRoutes = (list) => {
  return list.map((item) => {
    const config = require(`../pages/models/${item.name}Config`);
    const slug = inflector.dasherize(inflector.underscore(item.name));

    return {
      id: inflector.titleize(item.name),
      path: `/models/${slug}`,
      model: inflector.singularize(item.name),
      component: CrudIndexPage,
      provider: CrudProvider,
      config,
      crud: [
        {
          path: `/models/${slug}/:id`,
          name: `View ${inflector.titleize(inflector.singularize(item.name))}`,
          component: CrudViewPage,
          provider: CrudProvider,
          model: inflector.singularize(item.name),
          config,
        },
        {
          path: `/models/${slug}/add`,
          name: `Add ${inflector.titleize(inflector.singularize(item.name))}`,
          component: CrudViewPage,
          provider: CrudProvider,
          model: inflector.singularize(item.name),
          config,
        },
      ],
    };
  });
};

const crudSidebarMenu = [...getSidebarMenu(CRUD_MODELS)];
const modelCrudRoutes = [...getCrudRoutes(CRUD_MODELS)];

const publicMapRoutes = {
  header: "Data Access",
  id: "Map Explorer",
  icon: <MapIcon />,
  path: "/data-access/map-explorer",
  name: "Map Explore",
  component: PublicMap,
};

const reportsRoutes = {
  id: "Water Quality Report Card",
  icon: <FileText />,
  path: "/data-access/water-quality-report-card",
  name: "Water Quality Report Card",
  component: WaterQualityReportCard,
  guard: AuthGuard,
  visibilityFilter: UserVisibilityFilter,
};

const queryAndDownloadRoute = {
  id: "Query and Download",
  icon: <Download />,
  path: "/data-access/query-and-download",
  name: "Query and Download",
  component: QueryAndDownload,
  guard: AuthGuard,
  visibilityFilter: UserVisibilityFilter,
};

const editBenchmarksRoute = {
  header: "Data Management",
  id: "Edit Benchmarks",
  icon: <Search />,
  path: "/data-management/edit-benchmarks",
  name: "Edit Benchmarks",
  component: EditBenchmarks,
  guard: AdminGuard,
  visibilityFilter: AdminVisibilityFilter,
};

// const dataAccessRoutes = {
//   id: "Graph Explorer",
//   icon: <Activity />,
//   path: "/data-access/graph-explorer",
//   name: "Graph Explorer",
//   component: Blank,
// };
//
// const reportsRoutes = {
//   id: "Query & Download",
//   icon: <FileText />,
//   path: "/data-access/query-&-download",
//   name: "Query & Download",
//   component: Blank,
// };

const accountRoutes = {
  id: "Account",
  path: "/account",
  name: "Account",
  header: "Pages",
  icon: <Users />,
  component: Account,
  children: [
    {
      path: ROUTES.USER_PROFILE,
      name: "Profile",
      component: Profile,
    },
    {
      path: "/auth/logout",
      name: "Logout",
      component: function Logout() {
        const { logout } = useAuth0();
        logout();
      },
    },
  ],
};

const landingRoutes = {
  id: "Landing Page",
  path: "/",
  header: "Docs",
  icon: <Monitor />,
  component: Landing,
  children: null,
};

const mainRoutes = {
  header: "Dashboards",
  id: "Greeley Water Quality Dashboard",
  path: "/dashboard",
  icon: <Home />,
  component: Default,
  children: null,
  containsHome: true,
};

// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  mainRoutes,
  // dataAccessRoutes,
  // reportsRoutes,
  accountRoutes,
  reportsRoutes,
  queryAndDownloadRoute,
  editBenchmarksRoute,
];

export const dashboardMaxContentLayoutRoutes = [
  ...crudSidebarMenu,
  ...modelCrudRoutes,
  publicMapRoutes,
];

// Routes using the Auth layout
export const authLayoutRoutes = [accountRoutes];

// Routes using the Presentation layout
export const presentationLayoutRoutes = [landingRoutes];

// Routes using the full screen map layout
export const fullscreenMapRoutes = [];

// Routes visible in the sidebar
export const sidebarRoutes = [
  mainRoutes,
  ...crudSidebarMenu,
  publicMapRoutes,
  reportsRoutes,
  queryAndDownloadRoute,
  editBenchmarksRoute,
  // dataAccessRoutes,
  // reportsRoutes,
];
